module.exports = __webpack_public_path__ + "img/405.a9d9233f.png";